module.exports = __webpack_public_path__ + "static/media/product_02.9e128dd9.jpg";